import { render, staticRenderFns } from "./template.html?vue&type=template&id=74c1e90d&scoped=true&"
import script from "./Junanaho.vue?vue&type=script&lang=js&"
export * from "./Junanaho.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=74c1e90d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1e90d",
  null
  
)

export default component.exports